import { Form, message } from 'antd'
import { useEffect, useMemo, useReducer } from 'react'
import { useTypedSelector } from '../../redux/store'
import { usePageCache, useSkipInitEffect } from '../../tools/utilHooks'
import { useLocation } from 'react-router-dom'
import reducer, {
  initialState,
  resetStateAction,
  setDataSource,
  setFormDataAction,
  setIsAddModalVisivle,
  setSelectedRowKeys,
  setIsSubmitButtonLoadingAction,
  setIsSubmitFailure,
  reloadStateAction,
  // setSubmitFailInfo,
  // setIsDisabledSubmit,
} from './reducer'
import {
  ADD_PAYMENT_REQUEST,
  // VALIDATE_BY_ORDER_IDS,
} from '../../api/paymentOrder'
import { setModuleDataAction } from '../../modules/pagecache'
import { useDispatch } from 'react-redux'
import { signVoucherStateDict } from '../../tools/state'
import { isResponseCodeSuccess } from '../../tools/util'

export default function useHook() {
  const { pathname } = useLocation()
  const CACHE_KEY = pathname
  const dispatchRedux = useDispatch()
  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const [state, dispatch] = useReducer(reducer, initialState)
  const { enterpriseInfo } = useTypedSelector((state) => state.homeData)
  const {
    dataSource,
    isAddModalVisivle,
    selectedRowKeys,
    invoiceData,
    isSubmitButtonLoading,
    isSubmitFailure,
    isDisabledSubmit,
    submitFailInfo,
  } = state
  const totalPrice = useMemo(
    () =>
      dataSource
        .map((item) => item.finalPrice)
        .reduce((x, y) => {
          return x + y
        }, 0),
    [dataSource],
  )
  const { closeCurrentTab } = usePageCache()
  const [form] = Form.useForm()
  const { state: jumpState } = useLocation()

  // 提交付款申请
  const handleSubmit = async () => {
    const formValues = await form.validateFields()
    dispatch(setIsSubmitButtonLoadingAction(true))
    const res = await ADD_PAYMENT_REQUEST({
      orderIds: dataSource.map((item) => item.orderId),
      paymentPrice: totalPrice.toFixed(2),
      remark: formValues.remark,
    })
    dispatch(setIsSubmitButtonLoadingAction(false))
    if (isResponseCodeSuccess(res.code)) {
      message.success('操作成功')
      handleClosePage()
      // else {
      //   message.destroy()
      //   dispatch(
      //     setSubmitFailInfo({
      //       applyAmount: res.data.applyAmount,
      //       countAmount: res.data.countAmount,
      //       countApplyAmount: res.data.countApplyAmount,
      //       time: moment(res.data.time).format('YYYY-MM-DD HH:mm:ss'),
      //     }),
      //   )
      //   dispatch(setIsSubmitButtonLoadingAction(false))
      //   dispatch(setIsSubmitFailure(true))
      // }
    }
  }

  const handleAddOrderModalCancel = () => {
    dispatch(setIsAddModalVisivle(false))
  }

  // 表格选中操作
  const onChangeCheck = (selectedRowKeys: any[]) => {
    dispatch(setSelectedRowKeys(selectedRowKeys))
  }

  const handleAddClick = () => {
    dispatch(setIsAddModalVisivle(true))
  }

  const handleAddFinished = (selectedRows: any[]) => {
    // 收集已有的OrderNo，用于去重
    const orderNoList = dataSource.map((item) => {
      return item.orderNo
    })
    const addRows = selectedRows.filter((item) => {
      return !orderNoList.includes(item.orderNo)
    })
    dispatch(setDataSource([...dataSource, ...addRows]))
    dispatch(setIsAddModalVisivle(false))
  }

  const handleDelRows = () => {
    dispatch(
      setDataSource(
        dataSource.filter((item) => {
          // return !selectedRowKeys.includes(item.orderNo)  //蔡承涛编写
          return !selectedRowKeys.includes(item.id)
        }),
      ),
    )
    dispatch(setSelectedRowKeys([]))
  }

  const handleClosePage = () => {
    closeCurrentTab()
    resetGlobalState()
  }

  const handleFormDataChange = (changedValues: any, allValues: any) => {
    dispatch(setFormDataAction(allValues))
  }

  const resetGlobalState = () => {
    dispatch(resetStateAction())
  }

  // 关闭提交失败弹窗
  const closeSubmitFailureModal = () => {
    dispatch(setIsSubmitFailure(false))
  }

  // 获取缓存数据
  const getpagecache = () => {
    const data = pagekey.filter((item) => item.key === CACHE_KEY)
    if (data.length === 1) {
      return data[0].data
    }
    return null
  }

  // // 审核订单明细三要素
  // const reviewDataSource = async (dataSource: any) => {
  //   const ids = dataSource.map((item: any) => item.id).join(',')
  //   const res = await VALIDATE_BY_ORDER_IDS({ orderIdList: ids })
  //   if (isResponseCodeSuccess(res.code)) {
  //     const reviewData: any = []
  //     res.data.forEach((item) =>
  //       dataSource.forEach((term: any) => {
  //         if (item.orderId === term.id) {
  //           reviewData.push({ ...item, ...term })
  //         }
  //       }),
  //     )
  //     dispatch(setDataSource(reviewData))
  //     if (
  //       reviewData.every(
  //         (item: any) =>
  //           item.signVoucherStateReview === 1 &&
  //           item.customerReturnProgressReview === 1 &&
  //           item.orderSupplierOpenInvoiceStatusReview === 1,
  //       )
  //     ) {
  //       dispatch(setIsDisabledSubmit(false))
  //       message.success('三要素复核完成！')
  //     } else {
  //       message.error('三要素复核时出现异常，请联系管理员核对')
  //     }
  //   }
  // }

  // 动态计算最终价格
  useEffect(() => {
    // setSupplierName(GetLocalStorage('')))
    if ((jumpState as any)?.data) {
      form.resetFields()
      const data = (jumpState as any)?.data.map((item: any) => {
        return {
          ...item,
          signVoucherState: (signVoucherStateDict as any)?.[
            item.signVoucherState
          ],
        }
      })
      dispatch(setDataSource(data))
      // message.loading('三要素复核中，请稍等', 0)
      // 调用接口判断三要素是否复核通过
      // reviewDataSource(data)
    } else {
      const flag = getpagecache()
      dispatch(reloadStateAction(flag))
      form.setFieldsValue(flag.formData)
    }
    // eslint-disable-next-line
  }, [])

  useSkipInitEffect(() => {
    // 缓存数据
    const action = setModuleDataAction({
      key: CACHE_KEY,
      data: state,
    })
    dispatchRedux(action)
    // eslint-disable-next-line
  }, [state])

  return {
    selectedRowKeys,
    dataSource,
    enterpriseInfo,
    form,
    isAddModalVisivle,
    invoiceData,
    totalPrice,
    handleAddClick,
    handleAddOrderModalCancel,
    handleAddFinished,
    handleDelRows,
    handleSubmit,
    onChangeCheck,
    handleClosePage,
    handleFormDataChange,
    isSubmitButtonLoading,
    isSubmitFailure,
    isDisabledSubmit,
    submitFailInfo,
    closeSubmitFailureModal,
  }
}
import { Form, message } from 'antd'
import { useEffect, useMemo, useReducer } from 'react'
import { useTypedSelector } from '../../redux/store'
import { usePageCache, useSkipInitEffect } from '../../tools/utilHooks'
import { useLocation } from 'react-router-dom'
import reducer, {
  initialState,
  resetStateAction,
  setDataSource,
  setFormDataAction,
  setIsAddModalVisivle,
  setSelectedRowKeys,
  setIsSubmitButtonLoadingAction,
  setIsSubmitFailure,
  reloadStateAction,
  // setSubmitFailInfo,
  // setIsDisabledSubmit,
} from './reducer'
import {
  ADD_PAYMENT_REQUEST,
  // VALIDATE_BY_ORDER_IDS,
} from '../../api/paymentOrder'
import { setModuleDataAction } from '../../modules/pagecache'
import { useDispatch } from 'react-redux'
import { signVoucherStateDict } from '../../tools/state'
import { isResponseCodeSuccess } from '../../tools/util'

export default function useHook() {
  const { pathname } = useLocation()
  const CACHE_KEY = pathname
  const dispatchRedux = useDispatch()
  const { pagekey } = useTypedSelector((state) => state.pageCache)
  const [state, dispatch] = useReducer(reducer, initialState)
  const { enterpriseInfo } = useTypedSelector((state) => state.homeData)
  const {
    dataSource,
    isAddModalVisivle,
    selectedRowKeys,
    invoiceData,
    isSubmitButtonLoading,
    isSubmitFailure,
    isDisabledSubmit,
    submitFailInfo,
  } = state
  const totalPrice = useMemo(
    () =>
      dataSource
        .map((item) => item.finalPrice)
        .reduce((x, y) => {
          return x + y
        }, 0),
    [dataSource],
  )
  const { closeCurrentTab } = usePageCache()
  const [form] = Form.useForm()
  const { state: jumpState } = useLocation()

  // 提交付款申请
  const handleSubmit = async () => {
    const formValues = await form.validateFields()
    dispatch(setIsSubmitButtonLoadingAction(true))
    const res = await ADD_PAYMENT_REQUEST({
      orderIds: dataSource.map((item) => item.orderId),
      paymentPrice: totalPrice.toFixed(2),
      remark: formValues.remark,
    })
    dispatch(setIsSubmitButtonLoadingAction(false))
    if (isResponseCodeSuccess(res.code)) {
      message.success('操作成功')
      handleClosePage()
      // else {
      //   message.destroy()
      //   dispatch(
      //     setSubmitFailInfo({
      //       applyAmount: res.data.applyAmount,
      //       countAmount: res.data.countAmount,
      //       countApplyAmount: res.data.countApplyAmount,
      //       time: moment(res.data.time).format('YYYY-MM-DD HH:mm:ss'),
      //     }),
      //   )
      //   dispatch(setIsSubmitButtonLoadingAction(false))
      //   dispatch(setIsSubmitFailure(true))
      // }
    }
  }

  const handleAddOrderModalCancel = () => {
    dispatch(setIsAddModalVisivle(false))
  }

  // 表格选中操作
  const onChangeCheck = (selectedRowKeys: any[]) => {
    dispatch(setSelectedRowKeys(selectedRowKeys))
  }

  const handleAddClick = () => {
    dispatch(setIsAddModalVisivle(true))
  }

  const handleAddFinished = (selectedRows: any[]) => {
    // 收集已有的OrderNo，用于去重
    const orderNoList = dataSource.map((item) => {
      return item.orderNo
    })
    const addRows = selectedRows.filter((item) => {
      return !orderNoList.includes(item.orderNo)
    })
    dispatch(setDataSource([...dataSource, ...addRows]))
    dispatch(setIsAddModalVisivle(false))
  }

  const handleDelRows = () => {
    dispatch(
      setDataSource(
        dataSource.filter((item) => {
          // return !selectedRowKeys.includes(item.orderNo)  //蔡承涛编写
          return !selectedRowKeys.includes(item.id)
        }),
      ),
    )
    dispatch(setSelectedRowKeys([]))
  }

  const handleClosePage = () => {
    closeCurrentTab()
    resetGlobalState()
  }

  const handleFormDataChange = (changedValues: any, allValues: any) => {
    dispatch(setFormDataAction(allValues))
  }

  const resetGlobalState = () => {
    dispatch(resetStateAction())
  }

  // 关闭提交失败弹窗
  const closeSubmitFailureModal = () => {
    dispatch(setIsSubmitFailure(false))
  }

  // 获取缓存数据
  const getpagecache = () => {
    const data = pagekey.filter((item) => item.key === CACHE_KEY)
    if (data.length === 1) {
      return data[0].data
    }
    return null
  }

  // // 审核订单明细三要素
  // const reviewDataSource = async (dataSource: any) => {
  //   const ids = dataSource.map((item: any) => item.id).join(',')
  //   const res = await VALIDATE_BY_ORDER_IDS({ orderIdList: ids })
  //   if (isResponseCodeSuccess(res.code)) {
  //     const reviewData: any = []
  //     res.data.forEach((item) =>
  //       dataSource.forEach((term: any) => {
  //         if (item.orderId === term.id) {
  //           reviewData.push({ ...item, ...term })
  //         }
  //       }),
  //     )
  //     dispatch(setDataSource(reviewData))
  //     if (
  //       reviewData.every(
  //         (item: any) =>
  //           item.signVoucherStateReview === 1 &&
  //           item.customerReturnProgressReview === 1 &&
  //           item.orderSupplierOpenInvoiceStatusReview === 1,
  //       )
  //     ) {
  //       dispatch(setIsDisabledSubmit(false))
  //       message.success('三要素复核完成！')
  //     } else {
  //       message.error('三要素复核时出现异常，请联系管理员核对')
  //     }
  //   }
  // }

  // 动态计算最终价格
  useEffect(() => {
    // setSupplierName(GetLocalStorage('')))
    if ((jumpState as any)?.data) {
      form.resetFields()
      const data = (jumpState as any)?.data.map((item: any) => {
        return {
          ...item,
          signVoucherState: (signVoucherStateDict as any)?.[
            item.signVoucherState
          ],
        }
      })
      dispatch(setDataSource(data))
      // message.loading('三要素复核中，请稍等', 0)
      // 调用接口判断三要素是否复核通过
      // reviewDataSource(data)
    } else {
      const flag = getpagecache()
      dispatch(reloadStateAction(flag))
      form.setFieldsValue(flag.formData)
    }
    // eslint-disable-next-line
  }, [])

  useSkipInitEffect(() => {
    // 缓存数据
    const action = setModuleDataAction({
      key: CACHE_KEY,
      data: state,
    })
    dispatchRedux(action)
    // eslint-disable-next-line
  }, [state])

  return {
    selectedRowKeys,
    dataSource,
    enterpriseInfo,
    form,
    isAddModalVisivle,
    invoiceData,
    totalPrice,
    handleAddClick,
    handleAddOrderModalCancel,
    handleAddFinished,
    handleDelRows,
    handleSubmit,
    onChangeCheck,
    handleClosePage,
    handleFormDataChange,
    isSubmitButtonLoading,
    isSubmitFailure,
    isDisabledSubmit,
    submitFailInfo,
    closeSubmitFailureModal,
  }
}
